import { DEFAULT_FILTERS } from "./useCopilotInbox";

// Compact overview above the inbox. Numbers come from the backend statistics
// endpoint (scoped to what the viewer may see). Each tile also applies the
// matching filter. "Unread" counts conversations holding customer messages no
// one has read; it is deliberately a different tile (and tint) from the
// unresolved request count.
export default function StatsBar({ inbox }) {
  const { t, stats, filters } = inbox;
  const same = (patch) => Object.keys(patch).every((key) => filters[key] === patch[key]);
  const tiles = stats
    ? [
        { key: "unresolved", value: stats.unresolved, patch: { ...DEFAULT_FILTERS, status: "unresolved" }, hint: t.stats.unresolvedHint },
        { key: "unassigned", value: stats.unassigned, patch: { ...DEFAULT_FILTERS, status: "unresolved", assignedTo: "unassigned" }, hint: null },
        { key: "pending", value: stats.byStatus.pending, patch: { ...DEFAULT_FILTERS, status: "pending" }, hint: t.statusHints.pending },
        { key: "resolved", value: stats.byStatus.resolved, patch: { ...DEFAULT_FILTERS, status: "resolved" }, hint: null },
        { key: "unread", value: stats.unreadByAdmin, patch: { ...DEFAULT_FILTERS, status: "unresolved", unread: true }, hint: t.stats.unreadHint, attention: true },
      ]
    : null;

  return (
    <section className="ca-stats" aria-label={t.stats.regionLabel}>
      {(tiles || Array.from({ length: 5 })).map((tile, index) =>
        tile ? (
          <button
            key={tile.key}
            type="button"
            className={`ca-stat ca-stat-${tile.key} ${tile.attention && tile.value > 0 ? "attention" : ""}`}
            aria-pressed={same(tile.patch)}
            title={tile.hint || undefined}
            onClick={() => inbox.applyFilters(tile.patch)}
          >
            <span className="ca-stat-value">{tile.value}</span>
            <span className="ca-stat-label">{t.stats[tile.key]}</span>
          </button>
        ) : (
          <span key={index} className="ca-stat ca-stat-skeleton" aria-hidden="true" />
        ),
      )}
    </section>
  );
}
